<template>
	<BasePopover
		:id="$options.name"
		:ref="$options.name"
		class-list="popover-payment"
		:placement="placement"
		:status.sync="status"
		:target-id="targetId"
		:container="container"
	>
		<template #title>
			<div class="title">
				<span>{{ $t("Méthode de paiement") }}</span>
				<span v-if="onboarding" class="float-right">{{ `${current_popover_showed}/${total_popovers_to_show}` }}</span>
			</div>
		</template>

		<template #default>
			<b-form-group :label="$t('Vous voulez être payé via :')">
				<b-form-checkbox
					v-for="option in options"
					:key="option.value"
					v-model="_paymentMethods"
					class="option-border"
					:value="option.value"
				>
					{{ option.text }}
				</b-form-checkbox>
			</b-form-group>

			<hr />

			<div class="paymentDelay">
				<span> {{ $t("Sous") }} </span>
				<b-input v-model="_paymentDelay" class="input-sinao grey-border" style="height: 32px; width: 57px" />
				<span> {{ $t("jours") }}. </span>
			</div>

			<p class="mt-2 label grey-color">
				{{ $t("Inscrire \"0\" jour pour un paiement \"au comptant\".") }}
			</p>

			<hr />

			<s-button type="" @click="onSubmit">
				{{ onboarding ? $t("Suivant") : $t("Enregistrer") }}
			</s-button>
		</template>
	</BasePopover>
</template>

<script>
	import { query } from "sinao-corejs";
	import { mapState, mapGetters } from "vuex";
	import dayjs from "dayjs";
	import i18n from "@/i18n";

	function replaceLast(find, replace, string) {
		var lastIndex = string.lastIndexOf(find);

		if (lastIndex === -1) {
			return string;
		}

		var beginString = string.substring(0, lastIndex);
		var endString = string.substring(lastIndex + find.length);

		return beginString + replace + endString;
	}

	export default {
		name: "PopoverPayment",
		props: {
			targetId: {
				type: String,
				required: true
			},
			placement: {
				type: String,
				required: false,
				default: "right"
			},
			container: {
				type: String,
				required: false,
				default: "body"
			}
		},
		data() {
			return {
				paymentMethodsArray: null,
				tempoDelayInput: null
			};
		},
		computed: {
			...mapState({
				appId: state => state.app.id,
				writtingDate: state => state.home.writtingDate,
				onboarding: state => state.onboarding.onboarding,
				paymentTextDaysTemplate: state => state.home.paymentTextDaysTemplate,
				paymentTextNowTemplate: state => state.home.paymentTextNowTemplate,
				loadedDocument: state => state.home.loadedDocument,
        total_popovers_to_show: state => state.onboarding.total_popovers_to_show,
        current_popover_showed: state => state.onboarding.current_popover_showed,
        available_payment_methods: state => state.settings.defaultConfig.accounting.delay.payment['payment-methods']
			}),
			...mapGetters(['paymentMethods', 'paymentDelay', 'computedPrintableLang', 'config']),
			status: {
				get() {
					return this.$store.state.onboarding.showPopoverPayment;
				},
				set(value) {
					this.$store.commit("showPopoverPayment", value);
				}
			},
			paymentTextDays: {
				get() {
					return this.$store.state.home.paymentTextDays;
				},
				set(value) {
					this.$store.commit("paymentTextDays", value);
				}
			},
			dueDate() {
				return dayjs(this.writtingDate)
					.add(this.paymentDelay, "day")
					.format("DD/MM/YYYY");
			},
			monitor() {
				return {
					paymentDelay: this.paymentDelay,
					paymentMethods: this.paymentMethods,
					writtingDate: this.writtingDate,
          selectedLang: this.computedPrintableLang,
				};
			},
			_paymentDelay: {
				get() {
					return this.paymentDelay;
				},
				set(value) {
					this.$store.commit("paymentDelayClient", null);
					// make a timeout to avoid toast at each new keyboard hit
					if (this.tempoDelayInput)
						clearTimeout(this.tempoDelayInput);
					this.tempoDelayInput = setTimeout(() => {
						this.$store.commit("paymentDelayConfig", value);
					}, 800);

				}
			},
			_paymentMethods: {
				get() {
					if (!this.paymentMethods) return [];
					return this.paymentMethods.split(',').map(method => method.trim().toLowerCase());
				},
				set(value) {
					if (value !== null) {
						this.$store.commit("paymentMethodsClient", null);
						this.$store.commit("paymentMethodsConfig", value);
					}
				}
			},
      options() {
        if (!this.available_payment_methods) return [];
        return this.available_payment_methods.split(",").map(method => {
          return { text: i18n.t(method.trim()), value: method.trim() }
        })
      }
		},
		watch: {
			monitor: {
				handler() {
					const { textDays } = this.generateTextOutput();
					this.$store.commit("paymentTextDays", textDays);

          /*
          this.options = [
            { text: i18n.t("carte bancaire"), value: "carte bancaire" },
            { text: i18n.t("virement bancaire"), value: "virement bancaire" },
            { text: i18n.t("chèque"), value: "chèque" },
            { text: i18n.t("espèce"), value: "espèce" },
            { text: i18n.t("prélèvement bancaire"), value: "prélèvement bancaire" },
            { text: i18n.t("cesu"), value: "cesu" },
            { text: i18n.t("prélèvement urssaf (aici)"), value: "prélèvement urssaf (aici)" },
            { text: i18n.t("application de paiement"), value: "application de paiement" },
          ];
          */

          // update textDays
          this.$store.commit("paymentTextDays", this.generateTextOutput());

				},
				deep: true,
				immediate: true
			}
		},
		methods: {
      initOptions() {
        /*
        [
          { text: i18n.t("carte bancaire"), value: "carte bancaire" },
          { text: i18n.t("virement bancaire"), value: "virement bancaire" },
          { text: i18n.t("chèque"), value: "chèque" },
          { text: i18n.t("espèce"), value: "espèce" },
          { text: i18n.t("prélèvement bancaire"), value: "prélèvement bancaire" },
          { text: i18n.t("cesu"), value: "cesu" },
          { text: i18n.t("prélèvement urssaf (aici)"), value: "prélèvement urssaf (aici)" },
          { text: i18n.t("application de paiement"), value: "application de paiement" },
        ]
        */
        return this.payment_methods.map(method => {
          return { text: i18n.t(method), value: method }
        })
      },
      onSubmit() {
        if (this.paymentMethods && this.paymentMethods.length === 0 || this.paymentDelay.length === 0) return
        query({
          operationId: "app.settings.update",
          params: {
            appId: this.appId
          },
          data: {
            settings: {
              "installation.onboarding.showPopoverPayment": 1,
              // stop recording payment-methods in app->settings
              //"accounting.delay.payment.payment-methods": this.paymentMethodsArray.join(",").toLowerCase()
            }
          }
        });

        this.next();
      },
      next() {
        query({
          operationId: "app.settings.update",
          params: {
            appId: this.appId
          },
          data: {
            settings: {
              "installation.onboarding.showPopoverPayment": 1
            }
          }
        });

        this.status = false;
        this.$store.commit("setPopovers", { key: "showPopoverPayment", value: false });
        this.$nextTick(() => {
          this.$store.dispatch('setNextOpenedPopover');
          this.$store.dispatch('incrementCurrentPopoverShowed');
        });
      },
      generateTextOutput() {
        let payments = [];
        if (this.paymentMethods) {
          if (!Array.isArray(this.paymentMethods)) {
            payments = this.paymentMethods.split(/,\s?/).filter(elem => elem.length);
          } else {
            payments = this.paymentMethods;
          }
        }
		payments = payments.map((method) => i18n.t(method));

        let optionsString = payments.join(", ").toLowerCase();
        optionsString = replaceLast(",", " ou", optionsString);

        const textTemplate =
            this.paymentDelay === 0 ? this.paymentTextNowTemplate : this.paymentTextDaysTemplate;

        return textTemplate
            .replaceAll("{payment_methods}", optionsString)
            .replaceAll("{payment_period}", this.paymentDelay)
            .replaceAll("{due_date}", this.dueDate);
      }
    }
	};
</script>

<style lang="scss">
	.popover-payment {
		.option-border {
			border: 1px solid;
			border-radius: 5px;
			padding: 4px 0 6px 30px;
			margin-bottom: 8px;
			// width: 80%;
		}
	}
	.paymentDelay {
		display: flex;
		align-items: center;
	}
	.paymentDelay .input-sinao {
		margin-left: 5px;
		margin-right: 5px;
	}

	.input-sinao {
		border-color: var(--border) !important;
		border-radius: 6px !important;
		color: var(--text) !important;
	}
	.input-sinao:focus-within,
	.input-sinao:focus {
		border: 1px solid var(--text) !important;
		border-color: var(--text) !important;
		box-shadow: none !important;
	}
</style>
